export { default } from "./appendOwnerState.js";